var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.911 83.425 81.008 30h-11.01c0-11.048-8.955-20-19.999-20-11.045 0-20 8.951-20 19.999H18.993L10.09 83.425C9.485 87.038 11.991 90 15.66 90h68.682c3.665 0 6.171-2.962 5.569-6.575zM49.999 16.667c7.362 0 13.333 5.97 13.333 13.333H36.665c0-7.364 5.971-13.333 13.334-13.333zM16.861 83.333l7.779-46.666h5.358v6.666h6.667v-6.666h26.667v6.666h6.666v-6.666h5.361l7.777 46.666z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.082 50.833H46.034l3.965-3.965-3.535-3.535-7.644 7.644a3.332 3.332 0 0 0 0 4.713l7.644 7.644 3.531-3.535-3.965-3.965h11.052a7.915 7.915 0 0 1 7.916 7.917 7.92 7.92 0 0 1-7.916 7.916H29.999v5h27.083c7.135 0 12.916-5.781 12.916-12.916 0-7.137-5.781-12.918-12.916-12.918z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesReturn);
export default __webpack_public_path__ + "static/media/sales-return.f7d741c2d5fc29e79ded5ce5c8deeb03.svg";
export { ForwardRef as ReactComponent };